import { useMemo } from 'react';
import BigNumber from 'bignumber.js';
import { formatBalance } from 'shared/lib';

interface FormatBalanceArgs {
  maxDecimalDigits?: number;
  minDecimalDigits?: number;
  adaptiveDecimals?: boolean;
  maxTotalLength?: number;
  trimEllipsis?: boolean;
  decimals?: number;
  prettify?: boolean;
}

export const useFormattedBalance: typeof formatBalance = (
  balance: BigNumber | string | bigint = BigInt(0),
  {
    maxDecimalDigits = 4,
    maxTotalLength,
    adaptiveDecimals,
    trimEllipsis,
    decimals,
    minDecimalDigits,
    prettify,
  }: FormatBalanceArgs = {},
) => {
  return useMemo(
    () =>
      formatBalance(balance, {
        maxDecimalDigits,
        minDecimalDigits,
        maxTotalLength,
        adaptiveDecimals,
        trimEllipsis,
        decimals,
        prettify,
      }),
    [balance, maxDecimalDigits, minDecimalDigits, maxTotalLength, adaptiveDecimals, trimEllipsis, decimals, prettify],
  );
};
